/**
 * Error code for RemovalException. See also IllegalRemovalOperationException.cs
 */
export const RemovalErrorCode = 'illegal_removal_operation';
